import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DISTANCE_UNITS } from 'constants/measurement';
import { Image } from 'components/Image/Image';
import { Image as ImageModel, RES } from 'models/Image';

export class Venue extends PureComponent {
  handleRemoveClick = event => {
    event.stopPropagation();
    this.props.onRemoveClick(this.props.searchId);
  };

  getSublabel = () => {
    const { distance, distanceUnit, locationName } = this.props;
    const hasDistance = !!distance && !!distanceUnit;

    if (hasDistance && locationName) {
      return `${distance} ${distanceUnit} ${locationName}`;
    }
    if (hasDistance) {
      return `${distance} ${distanceUnit}`;
    }
    if (locationName) {
      return locationName;
    }

    return null;
  };

  render() {
    const {
      subtitle,
      images,
      highlighted,
      nameHighlighted,
      searchId,
      onClick,
      onMouseDown,
      onMouseMove,
      role,
      'aria-selected': ariaSelected,
      id,
    } = this.props;
    const title = `${nameHighlighted}${subtitle ? ` · ${subtitle}` : ''}`;
    const subLabel = this.getSublabel();

    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <li
        className={classNames('dropdown__item', {
          'dropdown__item--highlighted': highlighted,
        })}
        id={id}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        role={role}
        aria-selected={ariaSelected}>
        {images && (
          <div className="dropdown__item__image-container">
            <Image
              extraClass="dropdown__item__image"
              url={ImageModel.getImage(images, RES.low)}
              alt={nameHighlighted}
            />
            <div className="dropdown__item__image-border" />
          </div>
        )}
        <div className="dropdown__item__content">
          <span
            className="dropdown__item__label"
            dangerouslySetInnerHTML={{ __html: title }} // eslint-disable-line react/no-danger
          />
          {!!subLabel && <span className="dropdown__item__sublabel">{subLabel}</span>}
        </div>
        {searchId && (
          <div className="dropdown__item__remove" onClick={this.handleRemoveClick}>
            x
          </div>
        )}
      </li>
    );
  }
}

Venue.propTypes = {
  distance: PropTypes.string,
  distanceUnit: PropTypes.oneOf(Object.values(DISTANCE_UNITS)).isRequired,
  highlighted: PropTypes.bool.isRequired,
  images: PropTypes.object.isRequired,
  locationName: PropTypes.string,
  nameHighlighted: PropTypes.string.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  searchId: PropTypes.string,
  subtitle: PropTypes.string,
  'aria-selected': PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onMouseMove: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};
